export enum HazardDataStatus {
    Unknown = "Unknown",
    AwaitingApproval = "AwaitingApproval",
    Approved = "Approved",
    Declined = "Declined"
}